import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import TextField from '@mui/material/TextField';
import { styled } from '@mui/material/styles';
import React, { useState, useEffect } from 'react';

interface SystemPromptDialogProps {
  open: boolean;
  onClose: () => void;
  onSave: (prompt: string) => void;
  initialPrompt?: string;
}

const CodeTextField = styled(TextField)({
  '& .MuiInputBase-root': {
    fontFamily: 'monospace',
    fontSize: '1rem',
  },
});

const SystemPromptDialog: React.FC<SystemPromptDialogProps> = ({ open, onClose, onSave, initialPrompt = '' }) => {
  const [prompt, setPrompt] = useState<string>(initialPrompt);

  useEffect(() => {
    if (open) {
      setPrompt(initialPrompt);
    }
  }, [open, initialPrompt]);

  const handleSave = () => {
    onSave(prompt);
    onClose();
  };

  const handleClear = () => {
    setPrompt('');
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth='lg' fullWidth>
      <DialogTitle>Override System Prompt</DialogTitle>
      <DialogContent>
        <CodeTextField
          label='System Prompt'
          multiline
          rows={10}
          variant='outlined'
          fullWidth
          value={prompt}
          onChange={(e: React.ChangeEvent<HTMLTextAreaElement>) => setPrompt(e.target.value)}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClear}>Clear</Button>
        <Button onClick={onClose}>Cancel</Button>
        <Button onClick={handleSave} color='primary' variant='contained'>
          Save
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default SystemPromptDialog;
